"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilters = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _utils = require("../utils");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const useFilters = (initialFilters, onFilterChange) => {
  const [filters, updateFilters] = (0, _react.useState)((0, _utils.prepareFilters)(initialFilters));
  const handleFiltersChange = (0, _react.useCallback)(filter => {
    /** Не даем отжать последний фильтр */
    if (!filters || (0, _utils.getActiveFiltersCount)(filters) === 1 && filters[filter]) {
      return;
    }
    const newFiltersState = _objectSpread(_objectSpread({}, filters), {}, {
      [filter]: !filters[filter]
    });
    updateFilters(newFiltersState);
    if (onFilterChange) {
      onFilterChange(newFiltersState);
    }
  }, [filters, onFilterChange]);
  return [filters, handleFiltersChange];
};
exports.useFilters = useFilters;